import { Location } from "@relode/core/domain";

export class AddJobStep2Details {
    jobName: string;
    teamId: number;
    location: Location;
    normalizedJobName: string;
    normalizedLocation: Location;
    quantity: number;
    hoursPerWeek: number;
    contractDuration?: number;
    jobTypeId: number;
    jobSalaryInUSDollars?: number;
    jobSalaryTypeId: number;
    contractStartDate?: Date;
    contractDurationTypeId?: number;
    jobConcurrencyToken?: string;
}
